import React from "react";
import "./Header.css";
// import logoMegaLoto from "../assets/logo-megaloto.png"; // Agregar el logo de MegaLoto aquí
const logo = 'https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/empresa%2FlogoMegaLoto.png?alt=media&token=ddc64046-fd7a-459b-9a4f-ebba7b4e8dde'

const Header = () => (
  <header className="header">
    <img src={logo} alt="MegaLoto Logo" className="header-logo" />
    <h1 className="header-title">¡Gana Maquina Trimmer Buda con MegaLoto!</h1>
    <p className="header-subtitle">
      MegaLoto te trae este sorteo exclusivo. Participa con solo $200 y gana una máquina recargable premium.
    </p>
  </header>
);

export default Header;
